import { createSelector } from 'reselect';

const selectShippingTypes = (state: any) => state.shippingTypes;

export const selectShippingTypesCurrentItem = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.current);

export const selectShippingTypesListItems = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.list);


export const selectShippingTypesItemById = (itemId: any) =>
    createSelector(selectShippingTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShippingTypesCreatedItem = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.create);

export const selectShippingTypesUpdatedItem = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.update);

export const selectShippingTypesReadItem = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.read);

export const selectShippingTypesDeletedItem = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.delete);

export const selectShippingTypesSearchedItems = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.search);

export const selectShippingTypesItemsCount = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.count);

export const selectShippingTypesItemsFilter = createSelector([selectShippingTypes], (shippingTypes) => shippingTypes.filter);